import { gql } from '@apollo/client';

export const SWAP_USER_SEATS = gql`
  mutation SwapUserSeats($user1Id: ID!, $user2Id: ID!) {
    swapUserSeats(user1Id: $user1Id, user2Id: $user2Id) {
      success
      errors
      validationErrors
      user1 {
        id
        name
        email
        title
        role
        size
        pageQuota
        usedPages
      }
      user2 {
        id
        name
        email
        title
        role
        size
        pageQuota
        usedPages
      }
    }
  }
`; 